"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileTabs = void 0;
var ProfileTabs;
(function (ProfileTabs) {
    ProfileTabs["addresses"] = "addresses";
    ProfileTabs["general"] = "general";
    ProfileTabs["notifications"] = "notifications";
    ProfileTabs["settings"] = "settings";
    ProfileTabs["subscriptions"] = "subscriptions";
})(ProfileTabs || (exports.ProfileTabs = ProfileTabs = {}));
//# sourceMappingURL=tabs.js.map